"use client"

import Link from "next/link"
import { BridgeIcon } from "@/components/brand/BridgeIcon"
import { T, FM, MAXW } from "./_shared"

export default function ApertureFooter() {
  return (
    <footer style={{ borderTop: `1px solid ${T.hair}`, background: T.bgSoft }}>
      <div className={`${MAXW} mx-auto px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-5 gap-8`}>
        <div className="col-span-2">
          <Link href="/" className="flex items-center gap-3 select-none">
            <span className="relative flex h-[30px] w-[30px] items-center justify-center rounded-xl bg-gradient-to-br from-[#1F7A4E] via-[#0F5132] to-[#0A3D26] shadow-md shadow-[#0F5132]/40 ring-1 ring-white/[0.18]">
              <span className="absolute inset-0 rounded-xl bg-gradient-to-b from-white/[0.18] via-transparent to-transparent" />
              <span className="absolute inset-0 rounded-xl bg-gradient-to-t from-black/[0.18] via-transparent to-transparent" />
              <BridgeIcon size={18} className="text-white relative z-10 drop-shadow-sm" />
            </span>
            <span className="leading-none tracking-[-0.45px]">
              <span className="text-[15.5px] font-medium text-[rgba(15,13,10,0.72)]">Data</span>
              <span className="text-[15.5px] font-extrabold bg-gradient-to-r from-[#0F5132] via-[#34D399] to-[#0F5132] bg-clip-text text-transparent">Bridge</span>
            </span>
          </Link>
          <p className="mt-4 max-w-[36ch]" style={{ fontSize: 13, color: T.ink2, lineHeight: 1.6 }}>
            Email deliverability infrastructure for serious senders. Built for teams
            that actually measure their bounce rate.
          </p>

          {/* Product Hunt badge removed 2026-05-20. The dynamic
              "featured" embed rendered the live upvote count alongside
              the badge — a ~50-upvote / #92 launch isn't a credential
              that reads as social proof to a tech-savvy visitor.
              The footer is for navigation, not nostalgia. */}

          <p className="mt-6" style={{ fontSize: 11.5, color: T.ink3, fontFamily: FM, letterSpacing: "0.06em" }}>
            © {new Date().getFullYear()} DataBridge · All rights reserved
          </p>
        </div>
        {[
          // Trimmed the "Company" column to only links that resolve to
          // real destinations. Brand / Careers were placeholders that
          // showed up in the footer with href="#" — removed until they
          // exist. About anchors to the Founder section on the home;
          // Security to the Security section. DPA points to the new
          // /dpa page (legal-grade Data Processing Agreement).
          { h: "Product", l: [["Validators","#checks"],["Pricing","#pricing"],["Compare","#compare"],["Changelog","/changelog"]] },
          { h: "Company", l: [["About","/#founder"],["Status","/status"],["Contact","mailto:support@databridge.so"]] },
          { h: "Legal",   l: [["Privacy","/privacy"],["Terms","/terms"],["DPA","/dpa"],["Security","/#security"]] },
        ].map((c) => (
          <div key={c.h}>
            <p
              style={{
                fontFamily: FM, fontSize: 10.5, letterSpacing: "0.16em",
                textTransform: "uppercase", color: T.ink3,
              }}
            >
              {c.h}
            </p>
            <ul className="mt-4 flex flex-col gap-2.5">
              {c.l.map(([label, href]) => (
                <li key={label}><a href={href} style={{ fontSize: 13, color: T.ink2 }}>{label}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  )
}

